// @flow

import {Modal, Table} from 'antd';
import * as React from 'react';
import {withRouter} from 'react-router';
import type {Hero, Resistance, Skill, Weapon} from '../data/heroes';

type Props = {
  hero: ?Hero,
  isVisible: boolean,
  onOK: ()=>void
};

const columns = [
  {
    title: 'Attribute',
    dataIndex: 'attribute',
    key: 'attribute',
  },
  {
    title: 'Value',
    dataIndex: 'render',
    key: 'render',
  },
];

type Row = {
  attribute: string,
  render: React.Node
};

function CalculationResultDialog({hero, isVisible, onOK}: Props) {
  if (hero == null) return null;
  const rows: Array<Row> = [];
  rows.push({
    attribute: 'Role',
    render: <div>{hero.role}</div>,
  });
  rows.push({
    attribute: 'Element',
    render: <div>{hero.element}</div>,
  });
  rows.push({
    attribute: 'Weapons',
    render: hero.weapons
      .map((weapon: Weapon) => {
        return <div key={weapon}>{weapon}</div>;
      }),
  });
  rows.push({
    attribute: 'Level',
    render: <div>{'68'}</div>,
  });
  rows.push({
    attribute: 'Attack',
    render: <div>{hero.atk.toString()}</div>,
  });
  rows.push({
    attribute: 'Critical Hit Chance',
    render: <div>{Math.round(hero.criticalHitChance * 100) + '%'}</div>,
  });
  rows.push({
    attribute: 'HP',
    render: <div>{hero.hp.toString()}</div>,
  });
  rows.push({
    attribute: 'Defence',
    render: <div>{hero.def.toString()}</div>,
  });
  rows.push({
    attribute: 'Heal',
    render: <div>{hero.heal.toString()}</div>,
  });
  rows.push({
    attribute: 'Damage Reduction',
    render: <div>{hero.damageReduction.toString()}</div>,
  });
  rows.push({
    attribute: 'Card Slots',
    render: <div>{hero.cardSlot.toString()}</div>,
  });
  rows.push({
    attribute: 'Skills',
    render: hero.skills.map((skill: Skill, i: number) => {
      return <div key={i}>
        [{skill.target}] {skill.attribute} {Math.round(skill.value * 100)}%
      </div>;
    }),
  });
  rows.push({
    attribute: 'Resistance',
    render: hero.resistance.map((r: Resistance, i: number) => {
      return <div key={i}>
        {r.type}: {Math.round(r.value * 100)}%
      </div>;
    }),
  });
  return <Modal
    width={800}
    title={hero.name}
    visible={isVisible}
    onOk={onOK}
    onCancel={onOK}
  >
    <Table
      pagination={{defaultPageSize: 100, hideOnSinglePage: true}}
      columns={columns}
      dataSource={rows}
    />
  </Modal>;
}

export default withRouter(CalculationResultDialog);

